/**
 * Icons shared by the reviewer surfaces.
 *
 * Inline SVG rather than an asset file, matching `ReviewerChrome` and `AuditTrailView`: a
 * ds-shared component carries no app asset dependency, because the three apps keep their icons
 * in their own `src/assets/icons/` and ds-shared cannot reach into any of them.
 *
 * This module exists because `CheckIcon` was declared twice — byte for byte — once in
 * `ReviewerChrome` for its "reviewed" marker and again in `ReviewerActions` for the Mark as
 * reviewed button. One tick, one definition. Anything used by MORE THAN ONE ds-shared
 * component belongs here; an icon with a single caller stays local to it, which is why the
 * back / how-to / activity / close icons are still in `ReviewerChrome`.
 *
 * Components only, no other exports — a mixed module trips `react-refresh/only-export-components`.
 */

/** The tick: a finished review, and the button that finishes one. */
export function CheckIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}

/** The pencil: the action that SENDS what the reviewer wrote, as against merely signing off. */
export function PencilIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.1 2.1 0 1 1 3 3L7 19l-4 1 1-4Z" />
    </svg>
  );
}
